
import indexHTML from './partials/index.html?raw';
import aboutHTML from './partials/about.html?raw';
import newsHTML from './partials/news.html?raw';
import contributeHTML from './partials/contribute.html?raw';
import contactHTML from './partials/contact.html?raw';
import notebooksHTML from './partials/notebooks.html?raw';
import privacyHTML from './partials/privacy.html?raw';
import myAerovalHTML from './partials/my-aeroval.html?raw';

import { library, icon } from '@fortawesome/fontawesome-svg-core';
import { faFolderOpen, faFlask, faLaptop, faEye, faQuestionCircle, faUserPlus, faFingerprint, faLock, faCirclePlus, faRightToBracket, faUpload, faCog, faArrowRightToBracket, faRightFromBracket } from '@fortawesome/free-solid-svg-icons';

// Add the imported icons to the library
library.add(faFolderOpen, faFlask, faLaptop, faEye, faQuestionCircle, faUserPlus, faFingerprint, faLock, faCirclePlus, faRightToBracket, faUpload, faCog, faArrowRightToBracket, faRightFromBracket);

const folderOpenIcon = icon({ prefix: 'fas', iconName: 'folder-open' }).html[0];
const flaskIcon = icon({ prefix: 'fas', iconName: 'flask' }).html[0];
const laptopIcon = icon({ prefix: 'fas', iconName: 'laptop' }).html[0];
const eyeIcon = icon({ prefix: 'fas', iconName: 'eye' }).html[0];
const questionCircleIcon = icon({ prefix: 'fas', iconName: 'question-circle' }).html[0];
const userPlusIcon = icon({ prefix: 'fas', iconName: 'user-plus' }).html[0];
const fingerprintIcon = icon({ prefix: 'fas', iconName: 'fingerprint' }).html[0];
const lockIcon = icon({ prefix: 'fas', iconName: 'lock' }).html[0];
const circlePlusIcon = icon({ prefix: 'fas', iconName: 'circle-plus' }).html[0];
const rightToBracketIcon = icon({ prefix: 'fas', iconName: 'right-to-bracket' }).html[0];
const uploadIcon = icon({ prefix: 'fas', iconName: 'upload' }).html[0];
const settingsIcon = icon({ prefix: 'fas', iconName: 'cog' }).html[0];
const arrowRightToBracketIcon = icon({ prefix: 'fas', iconName: 'arrow-right-to-bracket' }).html[0];
const rightFromBracketIcon = icon({ prefix: 'fas', iconName: 'right-from-bracket' }).html[0];

import 'bootstrap';
import 'bootstrap5-toggle';
import 'bsky-embed/dist/bsky-embed.es.js'

import { globeJS } from './components/globe';
import { getCookie } from './components/cookies';
import { showAnimation } from './components/animation';
import { animateIcons } from './components/icons-animation';
import { initAPI, highchartsPalette } from './utils';
import { getConfig } from './utils';

import { initMyAeroval, signIn, showSignUp, signUp, showResetPassword, showPrivacyPolicy, hidePrivacyPolicy, resetPassword, logOut, submitEvaluation, enableSignUp, enableResetPassword, uploadModelData, makeConfigFile } from './modules/my-aeroval'

import './styles/style.css';
import './styles/theme.css';
import './styles/index.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import aerovalLogo from './assets/images/logo/full_logo.svg';
import glissEtAl from './assets/images/gliss2020_heatmap.webp';
import superComputer from './assets/images/pexels-manuel-geissinger-325229.webp';
import lightBulb from './assets/images/pexels-burak-k-132340.webp';
import privacy from './assets/images/erol-ahmed-d3pTF3r_hwY-unsplash.webp'
import notebook from './assets/images/notebook.webp';

import { renderHeader } from './components/header';
import { renderFooter } from './components/footer';

/*import interfaces*/
import { Aeroval } from './types/global';

// Extend the Globals interface
interface ExtendedGlobals extends Aeroval {
	cards: any[];
	counts: {
		[key: string]: {
			n: number;
			name: string;
			icon: string;
		};
	};
	obsArray: string[];
	modArray: string[];
}
declare var aeroval: ExtendedGlobals;

// Extend the Window interface to include your custom property
declare global {
	interface Window {
		aeroval?: {
			config?: Aeroval['config'];
			data?: Aeroval['data'];
			settings: Aeroval['settings'];
		};
	}
}

// Render header
const headerContainer = document.getElementById('header');
if (headerContainer instanceof HTMLDivElement) {
	headerContainer.appendChild(renderHeader());
}

// index
document.querySelector<HTMLDivElement>('#app')!.innerHTML =
	indexHTML.replace('{{aerovalLogo}}', aerovalLogo);

// about
document.querySelector<HTMLDivElement>('#app')!.innerHTML +=
	aboutHTML.replace('{{glissEtAl}}', glissEtAl);

// news
document.querySelector<HTMLDivElement>('#app')!.innerHTML +=
	newsHTML.replace('{{aeroval.setings.theme}}', aeroval.settings.theme);

// contribute
document.querySelector<HTMLDivElement>('#app')!.innerHTML +=
	contributeHTML.replace('{{superComputer}}', superComputer);

// contact
document.querySelector<HTMLDivElement>('#app')!.innerHTML +=
	contactHTML.replace('{{lightBulb}}', lightBulb).replace('{{questionCircleIcon}}', questionCircleIcon).replace('{{folderOpenIcon}}', folderOpenIcon).replace('{{flaskIcon}}', flaskIcon).replace('{{laptopIcon}}', laptopIcon).replace('{{eyeIcon}}', eyeIcon);

// notebooks
document.querySelector<HTMLDivElement>('#app')!.innerHTML +=
	notebooksHTML.replace('{{notebook}}', notebook);

// my-aeroval
document.querySelector<HTMLDivElement>('#app')!.innerHTML +=
	myAerovalHTML.replace('{{userPlusIcon}}', userPlusIcon).replace('{{fingerprintIcon}}', fingerprintIcon)
		.replace('{{lockIcon}}', lockIcon).replace('{{circlePlusIcon}}', circlePlusIcon)
		.replace('{{rightToBracketIcon}}', rightToBracketIcon)
		.replace('{{uploadIcon}}', uploadIcon)
		.replace('{{settingsIcon}}', settingsIcon)
		.replace('{{arrowRightToBracketIcon}}', arrowRightToBracketIcon)
		.replace('{{rightFromBracketIcon}}', rightFromBracketIcon);

// privacy
document.querySelector<HTMLDivElement>('#app')!.innerHTML +=
	privacyHTML.replace('{{privacy}}', privacy);



// Render footer
const footerContainer = document.getElementById('footer');
if (footerContainer instanceof HTMLDivElement) {
	footerContainer.appendChild(renderFooter());
}

function filterByKeywords(keywords: string) {
	keywords = keywords.replace('_', ' ');
	var shown_cards = 0;
	for (let card of aeroval.cards) {
		let cardElement = document.getElementById(card.id);
		if (cardElement && cardElement.parentElement) {
			if (keywords && !card.keywords.includes(keywords)) {
				cardElement.parentElement.style.display = 'none';
			} else {
				cardElement.parentElement.style.display = 'inline-block';
				shown_cards++;
			}
		}
	}
	const noDataElement = document.getElementById('noData');
	noDataElement!.style.display = shown_cards == 0 ? 'initial' : 'none';
}

function checkKey(event: KeyboardEvent, div: string): void {
	var code = event.key;
	var form = document.getElementById(div) as HTMLInputElement;
	if (code === 'Enter' || form.value == '') {
		filterByKeywords(form.value);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	init();
});

function init(): void {
	console.log('initialize index page');
	initAPI();

	const delay = 4000;
	const fade = 400;
	const theme = getCookie('theme') as Aeroval['Theme'];

	if (!window.location.href.endsWith('/') || document.referrer != '' || aeroval.settings.animation !== 'true') {
		//does not show animation if click on portal
		const animationElement = document.getElementById('animation');

		if (animationElement) {
			animationElement.classList.remove('d-flex', 'justify-content-center', 'align-items-center');
			animationElement.style.display = 'none';
		}

		const hash: string = new URL(window.location.href).hash;
		if (hash) {
			const contentMainIndexElement = document.querySelector(hash);
			if (contentMainIndexElement) {
				contentMainIndexElement.setAttribute('style', 'min-height: calc(100% - 250px); display: block !important');
			}
		} else {
			const contentMainIndexElement = document.querySelector('#index');
			if (contentMainIndexElement) {
				contentMainIndexElement.setAttribute('style', 'min-height: calc(100% - 250px); display: block !important');
			}
		}


		// launch globe animation
		globeJS();
	} else {
		showAnimation(theme, delay, fade)
	}

	/*animation on scroll*/
	window.addEventListener('scroll', () => {
		document.body.style.setProperty('--scroll', String(window.scrollY / window.innerHeight));
	},
		false
	);

	if (window.location.host.includes('cams2-83') || window.location.host.includes('regional-evaluation.atmosphere.copernicus.eu')) {
		location.href = `./pages/evaluation/?project=cams2-83`;
	} else if (window.location.host.includes('cams2-82') || window.location.host.includes('global-eqc-server.atmosphere.copernicus.eu')) {
		location.href = `./pages/evaluation/?project=cams2-82`;
	}

	// load projects
	if (window.location.href.endsWith('/')) {
		console.log('load projects');
		iniCounts();
		getProjects();
		filterProjects();
		animateIcons();
	}

	// init page
	if (window.location.href.endsWith('#my-aeroval')) initMyAeroval()
}

function filterProjects() {
	const inputElement = document.getElementById('kwForm') as HTMLInputElement;
	if (!inputElement) return
	inputElement.addEventListener('keyup', (event: KeyboardEvent) => {
		checkKey(event, 'kwForm');
	});
}

async function getProjects(): Promise<void> {
	if (window.DATA_PATH == '') {
		const projectsData = await getConfig('projects.json')
		aeroval.config.projects = projectsData;
		fillCards(projectsData);
	} else {
		const url = `${window.API_ROOT}/projects/${window.DATA_PATH && `?data_path=${window.DATA_PATH}`}`;
		fetch(url)
			.then((response) => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then((data) => {
				var projects: any = {}
				for (const project of data) {
					projects[project] = {
						url: `./pages/evaluation/?project=${project}`,
						title: project,
						subtitle: "",
						description: "No description",
						img: "",
						enabled: true,
						display: true,
						keywords: []
					}
				}
				aeroval.config.projects = projects;
				fillCards(projects);
			})
			.catch((error) => {
				console.error('Fetch error:', error);
			});
		addUserIcon()
	}

}

function addUserIcon() {
	const element = document.getElementById("globe-logo");
	if (!element) return
	element.insertAdjacentHTML('afterend', `<span class="position-absolute start-100 translate-middle badge rounded-pill bg-secondary" style="font-size: xx-small">
		${window.DATA_PATH}
	</span>`);
}

function fillCards(data: Aeroval['config']['projects']): void {
	if (!data) return;

	const keys = Object.keys(data);

	var j = 0; //card with no picture
	var h = '<div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-4">';
	var Keywords = [] as string[];
	aeroval.cards = [];

	for (let key of keys) {
		const display = data[key].display ? 'inline-block' : 'none';
		const enabled = data[key].enabled ? 'enabled' : 'disabled';
		const id = data[key].title.replace(' ', '_');

		if (display == 'none') continue;
		h += `<div class="col">`
		h += `<div id="${id}" class="card project ${enabled} border-0 shadow-sm p-0">`;

		//image
		if (data[key].img == '') {
			h += `<div class="container card-span-top" style="background-color: ${highchartsPalette(j)}"><span> ${data[key].title} </span></div>`;
			j++;
		} else {
			h += `<img class="card-img-top" src="${data[key].img}" alt="Card image cap">`;
		}

		h += `<div class="card-body">
			<h5 class="card-title"> ${data[key].title} </h5>
			<h6 class="card-subtitle mb-2 text-muted">${data[key].subtitle}</h6>
			<p class="card-text">${data[key].description}</p>`;
		if (data[key].enabled) {
			//if several urls, then several buttons
			if (Array.isArray(data[key].url) && Array.isArray(data[key].subprojects)) {
				const urls = data[key].url as string[];
				const subprojects = data[key].subprojects as string[];
				for (let j = 0; j < urls.length; j++) {
					if (j <= urls.length && j <= subprojects.length) {
						h += `<a href="${urls[j]}" class="btn btn-primary" style="margin-right: 5px">${subprojects[j]}</a>`;
					}
				}
			} else {
				h += `<a href="${data[key].url}" class="btn btn-primary stretched-link">${data[key].title}</a>`;
			}

			//add keywords
			Keywords = Keywords.concat(data[key].title);
			if (typeof data[key].keywords != 'undefined') {
				Keywords = Keywords.concat(data[key].keywords);
			}
			aeroval.cards.push({
				id: id,
				keywords: data[key].keywords.concat(data[key].title),
			});
		} else {
			h += `<a href="${data[key].url}" class="btn btn-primary stretched-link disabled">${data[key].title}</a>
				<br><span class="coming-soon"> Coming Soon</span>`
		}
		h += `</div>
			</div>
			</div>`
	}
	h += '</div>';

	const cards = document.querySelector('#cards');
	if (cards instanceof HTMLElement) {
		cards.innerHTML = h;
	}

	//remove duplicate keywords
	Keywords = Keywords.filter(onlyUnique);
	//send the list of stations to the statForm
	const kwForm = document.getElementById('kwForm');
	if (kwForm instanceof HTMLInputElement) {
		autocomplete(kwForm, Keywords);
	}
}

function onlyUnique(value: string, index: number, self: string[]) {
	return self.indexOf(value) === index;
}

function autocomplete(input: HTMLInputElement, arr: string[]) {
	/*the autocomplete function takes two arguments,
  the text field element and an array of possible autocompleted values:*/
	var currentFocus: number = 0;
	/*execute a function when someone writes in the text field:*/
	input.addEventListener('input', function () {
		var a,
			b,
			i,
			val = this.value;
		/*close any already open lists of autocompleted values*/
		closeAllLists();
		if (!val) {
			return false;
		}
		currentFocus = -1;
		/*create a DIV element that will contain the items (values):*/
		a = document.createElement('DIV');
		a.setAttribute('id', this.id + 'autocomplete-list');
		a.setAttribute('class', 'autocomplete-items');
		/*append the DIV element as a child of the autocomplete container:*/
		this?.parentNode?.appendChild(a);
		/*for each item in the array...*/
		for (i = 0; i < arr.length; i++) {
			/*check if the item starts with the same letters as the text field value:*/
			if (arr[i].substring(0, val.length).toUpperCase() == val.toUpperCase()) {
				/*create a DIV element for each matching element:*/
				b = document.createElement('DIV');
				/*make the matching letters bold:*/
				b.innerHTML = '<strong>' + arr[i].substring(0, val.length) + '</strong>';
				b.innerHTML += arr[i].substring(val.length);
				/*insert a input field that will hold the current array item's value:*/
				b.innerHTML += "<input type='hidden' value='" + arr[i] + "'>";
				/*execute a function when someone clicks on the item value (DIV element):*/
				b.addEventListener('click', function () {
					/*insert the value for the autocomplete text field:*/
					input.value = this.getElementsByTagName('input')[0].value;
					/*close the list of autocompleted values,
				  (or any other open lists of autocompleted values:*/
					closeAllLists();
					const inputElement = document.getElementById('kwForm') as HTMLInputElement | HTMLTextAreaElement | null;
					if (inputElement) {
						filterByKeywords(inputElement.value);
					}
				});
				a.appendChild(b);
			}
		}
	});
	/*execute a function presses a key on the keyboard:*/
	input.addEventListener('keydown', (e) => {
		let x: HTMLDivElement[] | undefined = undefined;
		let tempX = document.getElementById(input.id + 'autocomplete-list');
		if (tempX) {
			x = Array.from(tempX.getElementsByTagName('div')) as HTMLDivElement[];
		}
		if (e.key == 'ArrowDown') {
			currentFocus++;
			addActive(x);
		} else if (e.key == 'ArrowUp') {
			currentFocus--;
			addActive(x);
		} else if (e.key == 'Enter') {
			e.preventDefault();
			if (currentFocus > -1) {
				if (x) x[currentFocus].click();
			}
		}
	});

	function addActive(x: HTMLDivElement[] | undefined) {
		/*a function to classify an item as "active":*/
		if (!x) return false;
		/*start by removing the "active" class on all items:*/
		removeActive(x);
		if (currentFocus >= x.length) currentFocus = 0;
		if (currentFocus < 0) currentFocus = x.length - 1;
		/*add class "autocomplete-active":*/
		x[currentFocus].classList.add('autocomplete-active');
	}

	function removeActive(x: HTMLDivElement[] | undefined) {
		if (!x) return;
		/*a function to remove the "active" class from all autocomplete items:*/
		for (var i = 0; i < x.length; i++) {
			const element = x[i];
			if (element instanceof HTMLElement) {
				x[i].classList.remove('autocomplete-active');
			}
		}
	}

	function closeAllLists(element: EventTarget | null = null): void {
		// close all autocomplete lists in the document, except the one passed as an argument
		document.querySelectorAll('.autocomplete-items').forEach((item) => {
			if (element != item && element != input) {
				item?.parentNode?.removeChild(item);
			}
		});
	}
	/*execute a function when someone clicks in the document:*/
	document.addEventListener('click', function (e) {
		closeAllLists(e.target);
	});
}

function iniCounts(): void {
	aeroval.counts = {
		projects: {
			n: 0,
			name: 'projects',
			icon: folderOpenIcon,
		},
		experiments: {
			n: 0,
			name: 'experiments',
			icon: flaskIcon,
		},
		models: {
			n: 0,
			name: 'climate and aq models',
			icon: laptopIcon,
		},
		observations: {
			n: 0,
			name: 'observation datasets',
			icon: eyeIcon,
		},
	};
	const counts = Object.keys(aeroval.counts);
	for (let i: number = 0; i < counts.length; i++) {
		let counter = document.getElementById(`counter_${counts[i]}`);
		if (!counter) continue
		counter.innerHTML = `<div class="count_icon">${aeroval.counts[counts[i]].icon}</div>
			<div>
				<span id="counter_${counts[i]}_n" class="count_n">${0}</span>
				<span class="count_category d-flex align-items-center justify-content-center">${aeroval.counts[counts[i]].name}</span>
			</div>`;
	}
	getCounts();
}

async function getCounts(): Promise<void> {
	if (window.DATA_PATH == '') {
		const data = await getConfig('projects.json')
		countProjects(data);
	} else {
		const url = `${window.API_ROOT}/projects/${window.DATA_PATH && `?data_path=${window.DATA_PATH}`}`;
		fetch(url)
			.then((response) => {
				if (!response.ok) {
					throw new Error('Network response was not ok');
				}
				return response.json();
			})
			.then((data) => {
				var projects: any = {}
				for (const project of data) {
					projects[project] = {
						url: `./pages/evaluation/?project=${project}`,
						title: project,
						subtitle: "",
						description: "No description",
						img: "",
						enabled: true,
						display: true,
						keywords: []
					}
				}
				aeroval.config.projects = projects;
				countProjects(projects);
			})
			.catch((error) => {
				console.error('Fetch error:', error);
			});
	}
}

function countProjects(data: any): void {
	aeroval.obsArray = [];
	aeroval.modArray = [];
	getProjectExperiments(data);
}

async function getProjectExperiments(data: any) {
	const projects = Object.keys(data);
	const enabledProjects = []
	const promises = [];

	for (const project of projects) {
		if (data[project].enabled && data[project].display) {
			const url = `${window.API_ROOT}/experiments/${project}${window.DATA_PATH && `?data_path=${window.DATA_PATH}`}`;
			promises.push(fetch(url));
			enabledProjects.push(project)
		}
	}

	const responses = await Promise.allSettled(promises);

	// Filter out fulfilled promises and map responses to JSON
	const fulfilledResponses = responses.filter((response) => response.status === 'fulfilled').map((response) => (response as any).value.json());

	// Await parsing of JSON responses
	const projectsJSON = await Promise.all(fulfilledResponses);

	var i = 0
	for (const projectJSON of projectsJSON) {
		if (projectJSON) {
			try {
				var exps = Object.keys(projectJSON);
				aeroval.counts.projects.n++;
				getExperimentsMenus(enabledProjects[i], exps);
			} catch (error) {
				console.warn(`Error: Failed to parse JSON for ${projectJSON.url}`);
			}
		}
		i++
	}
}

async function getExperimentsMenus(project: string, experiments: string[]) {
	// list experiments files
	const promises = [];

	// Loop through each experiment to create promises for fetching files
	for (const experiment of experiments) {
		aeroval.counts.experiments.n++;
		const url = `${window.API_ROOT}/menu/${project}/${experiment}${window.DATA_PATH && `?data_path=${window.DATA_PATH}`}`;
		promises.push(fetch(url));
	}
	// update projects and experiments counter
	updateCount('projects', 0, aeroval.counts.projects.n, 500);
	updateCount('experiments', 0, aeroval.counts.experiments.n, 500);

	// Use Promise.allSettled() to fetch all files concurrently
	const responses = await Promise.allSettled(promises);

	// Filter out fulfilled promises and map responses to JSON
	const fulfilledResponses = responses.filter((response) => response.status === 'fulfilled').map((response) => (response as any).value.json());

	// Await parsing of JSON responses
	const menus = await Promise.all(fulfilledResponses);

	for (const menu of menus) {
		for (let variable in menu) {
			for (let obs in menu[variable].obs) {
				const obs_net = `${variable}-${obs}`;
				if (!aeroval.obsArray.includes(obs_net)) {
					aeroval.obsArray.push(obs_net);
				}
				for (let layer in menu[variable].obs[obs]) {
					//models
					for (let model in menu[variable].obs[obs][layer]) {
						if (!aeroval.modArray.includes(model)) {
							aeroval.modArray.push(model);
						}
					}
				}
			}
		}
	}
	// update observation and model counters
	updateCount('observations', 0, aeroval.obsArray.length, 500);
	updateCount('models', 0, aeroval.modArray.length, 500);
}

function updateCount(which: string, start: number, end: number, duration: number): void {
	const counter = document.getElementById(`counter_${which}_n`);
	if (!counter) return
	let startTimestamp = 0;
	if (!window.location.href.endsWith('/') || document.referrer != '' || aeroval.settings.animation !== 'true') {
		const step = (timestamp: number) => {
			if (!startTimestamp) startTimestamp = timestamp;
			let progress = Math.min((timestamp - startTimestamp) / duration, 1);
			counter.innerHTML = String(Math.floor(progress * (end - start) + start));
			if (progress < 1) {
				window.requestAnimationFrame(step);
			}
		};
		window.requestAnimationFrame(step);
	} else {
		//delay animation
		window.setTimeout(function () {
			const step = (timestamp: number) => {
				if (!startTimestamp) startTimestamp = timestamp;
				let progress = Math.min((timestamp - startTimestamp) / duration, 1);
				counter.innerHTML = String(Math.floor(progress * (end - start) + start));
				if (progress < 1) {
					window.requestAnimationFrame(step);
				}
			};
			window.requestAnimationFrame(step);
		}, 4000);
	}
}

// add some buttons interaction
const INTERACTIONS: Record<string, (event?: Event) => void | Promise<void>> = {
	'sign-in-but': signIn,
	'show-sign-up': showSignUp,
	'show-reset-password': showResetPassword,
	'show-privacy-policy': showPrivacyPolicy,
	'hide-privacy-policy': hidePrivacyPolicy,
	'resetpassword-but': resetPassword,
	'logout-but': logOut,
	'sign-up-but': signUp,
	'upload-but': uploadModelData,
	'make-cfg-but': makeConfigFile,
	'submit-but': submitEvaluation,
}

for (const [id, handler] of Object.entries(INTERACTIONS)) {
	const element = document.getElementById(id);
	element?.addEventListener("click", handler);
}

// add recaptcha action
const RECAPTCHA: Record<string, (response: string) => void> = {
	'enable-sign-up': enableSignUp,
	'enable-reset-password': enableResetPassword
};

// Expose functions globally so reCAPTCHA can call them
for (const [_id, handler] of Object.entries(RECAPTCHA)) {
	(window as any)[handler.name] = handler;
}
